import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ProductoTipo = {
    async Get() { return await methods.Get("ProductoTipo/Get"); },
    async Post(data) { return await methods.Post("ProductoTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("ProductoTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ProductoTipo/Delete" + useParamsJson(qs)) }
};

export default ProductoTipo;